import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import store from "../../../redux/store";
import _ from "lodash";
import Pagination from "../../givBee/pagination/Pagination";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";

class AccountRecipients extends Component {
  header = store.getState().adminHeader.adminHeader;
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "/viewAccount", uiname: "Account" },
    { pageid: "/accountSendHistory", uiname: "Send History" },
    { pageid: "", uiname: "Send History" },
  ];
  constructor(props) {
    super(props);
    let accountId = "";
    let eventName = "";
    let eventId = "";
    let smsMessageLog = null;
    let businessDomain = null;
    if (props.state) {
      accountId = props.state.accountId;
      eventId = props.state.eventId;
      eventName = props.state.eventName;
      smsMessageLog = props.state.smsMessageLog;
      businessDomain = props.state.businessDomain;
    }
    this.state = {
      accountId: accountId,
      eventId: eventId,
      eventName: eventName,
      businessDomain: businessDomain,
      id: smsMessageLog?.id,
      searchText: "",
      responseMessage: "",
      contactMessageLogId: "",
      textMessage: "",
      initialPage: 0,
      pageSize: 20,
      MessageActivityContactList: [],
      conversationList: [],
      messageName: smsMessageLog?.messageName,
      messageType: smsMessageLog?.messageType,
      render: false,
    };
    this.getRecipientList();
    this.debouncedSearch = _.debounce(this.getRecipientList, 800);
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }
  getRecipientList(pageNo, pageSize) {
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
      messageLog: {
        id: this.state.id,
      },
      eventId: this.state.eventId,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
      },
    };

    AdminFetchServerData.callPostService(
      "/messageLogReportms/getSmsLogHistory",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let MessageActivityContactList = output.data.logList;
        let page = output.data.page;
        for (let i = 0; i < MessageActivityContactList.length; i++) {
          MessageActivityContactList[i].mobile =
            Utils.viewTollFreeNumberFormate(
              MessageActivityContactList[i].mobile
            );
          MessageActivityContactList[i].createdOn = Utils.getUtcToLocalDateTimeZone(
            MessageActivityContactList[i].createdOn
          );
        }
        this.setState({
          render: true,
          MessageActivityContactList: MessageActivityContactList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
        });
      } 
    });
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex = counter !== undefined ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.MessageActivityContactList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allCheckBoxSelected: false,
        showToolbarBtn: false,
      });
    }
    this.getRecipientList(currentPageIndex, pageSize);

    this.setState({
      pageNo: currentPageIndex,
    });
  }

  viewCancel() {
    this.props.navigate("/accountSendHistory", {
      state: {
        action: "view",
        accountId: this.state.accountId,
        eventId: this.state.eventId,
        businessDomain: this.state.businessDomain,
        eventName: this.state.eventName,
      },
    });
  }
  recipientTitle() {
    return (
      <>
        {this.state.pageId === "sendHistory"
          ? "View details for text message send"
          : "View details for scheduled send"}
        :
        <span className="ms-1" style={{ color: "#337ab7" }}>
          {this.state.messageName}
        </span>
      </>
    );
  }
  render() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          backCallback={this.viewCancel.bind(this)}
          name={this.recipientTitle()}
        />
        <div className="row">
          <div className="col">
            <div className="col md-12 mt-2">
              <div className="card rounded-0">
                <div className="row justify-content-between p-2">
                  <div className="d-flex col-12 col-lg-5 col-xl-5">
                    <div className="col-12 text-start totalResults">
                      <span>Total Contacts: {this.state.totalRecords}</span>
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-7 col-xl-7">
                    <div className="col-12 text-end">
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.getRecipientList.bind(
                                  this,
                                  this.state.pageNo,
                                  this.state.pageSize
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table text-start table-hover">
                    <thead className="apPaginationTableThead">
                      <tr>
                        <th scope="col fw-bold">Mobile Number</th>
                        <th scope="col fw-bold">First Name</th>
                        <th scope="col fw-bold">Last Name</th>
                        <th scope="col fw-bold">Email</th>
                        <th scope="col fw-bold">Date/time added</th>
                        <th scope="col fw-bold">Status</th>
                        <th scope="col fw-bold">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.MessageActivityContactList?.map(
                        (rowData, index) => (
                          <tr key={index}>
                            <td style={{ width: "190px" }}>{rowData.mobile}</td>
                            <td style={{ width: "140px" }}>
                              {rowData.firstName}
                            </td>
                            <td style={{ width: "140px" }}>
                              {rowData.lastName}
                            </td>
                            <td style={{ width: "200px" }}>{rowData.email}</td>
                            <td style={{ width: "270px" }}>
                              {rowData.createdOn}
                            </td>
                            <td style={{ width: "140px" }}>
                              {rowData.deliveryStatus}
                            </td>
                            <td style={{ width: "250px" }}>
                              {rowData.errorMessage}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                {this.state.totalRecords === 0 && (
                  <div
                    className="row text-center"
                    style={{ padding: "6px 20px" }}
                  >
                    <h5 className="dataNotAvailable">No data found.</h5>
                  </div>
                )}
                {this.state.totalRecords > this.state.pageSize && (
                  <div className="row justify-content-between pagination p-1">
                    <div className="d-flex col-12 col-lg-4 col-xl-4">
                      <div className="pageSize col-12 text-start">
                        Page {this.state.pageNo + 1} of {this.state.totalPages}
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-8 col-xl-8">
                      <div className="col-12 text-end">
                        <Pagination
                          showPerPage={this.state.showPerPage}
                          onPaginationChange={this.onPaginationChange.bind(
                            this
                          )}
                          total={this.state.totalRecords}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(AccountRecipients);
